import { createContext } from 'react';

export const ModalContext = createContext({ onClose: () => {}, scrollToTop: () => {} });
